
const mNameFilter = new WeakMap();
const mEmailFilter = new WeakMap();
const mNotesFilter = new WeakMap();

const filterSpecKeysTable = Object.freeze({
    name: "name",
    email: "email",
    notes: "notes"
});

const filterSpecKeys = Object.values(filterSpecKeysTable);

const mFilterSpecsTable = new WeakMap();

class RecipientFilterSpecification {
    constructor() {
        mNameFilter.set(this, {
            filterType: filterSpecKeysTable.name,
            filterContent: null
        });

        mEmailFilter.set(this, {
            filterType: filterSpecKeysTable.email,
            filterContent: null
        });

        mNotesFilter.set(this, {
            filterType: filterSpecKeysTable.notes,
            filterContent: null
        });

        mFilterSpecsTable.set(this, new Map([
            [filterSpecKeysTable.name, mNameFilter.get(this)],
            [filterSpecKeysTable.email, mEmailFilter.get(this)],
            [filterSpecKeysTable.notes, mNotesFilter.get(this)]
        ]));
    }


    get name() {
        return mNameFilter.get(this);
    }

    get email() {
        return mEmailFilter.get(this);
    }

    get notes() {
        return mNotesFilter.get(this);
    }

    get allFilterContent() {
        let filterSpecsTable = mFilterSpecsTable.get(this);
        let combinedFilterContent = filterSpecKeys.map((filterKey) => {
            let fContent = filterSpecsTable.get(filterKey).filterContent;
            return (fContent != null) ? fContent : "null";
        }).join("|");

        return combinedFilterContent;
    }
}

RecipientFilterSpecification.FilterKeys = filterSpecKeys;

export default RecipientFilterSpecification;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/RecipientFilterSpecification.js
// module id = XdiJ
// module chunks = 1